// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {MeasuringBox} from '../../core/_models'
import {TOKENS} from '../../../../../../components/design-system'

type Props = {
  row: Row<MeasuringBox>
  hiddenColumns?: string[]
  index?: number
}

const CustomRow: FC<Props> = ({row, hiddenColumns, index = 0}) => {
  const altBg = index % 2 === 1 ? TOKENS.color.rowAlt : TOKENS.color.card
  return (
    <tr
      {...row.getRowProps()}
      style={{ backgroundColor: altBg, transition: 'background 80ms ease' }}
      onMouseEnter={(e) => { (e.currentTarget as HTMLTableRowElement).style.backgroundColor = TOKENS.color.rowHover }}
      onMouseLeave={(e) => { (e.currentTarget as HTMLTableRowElement).style.backgroundColor = altBg }}
    >
      {row.cells.map((cell) => {
        if (hiddenColumns && hiddenColumns.includes(cell.column.id)) return null
        const isActions = cell.column.id === 'actions'
        return (
          <td
            {...cell.getCellProps()}
            className={clsx({'text-end': isActions})}
            style={{
              padding: '18px 20px',
              borderBottom: `1px solid ${TOKENS.color.divider}`,
              fontSize: 13,
              color: TOKENS.color.text,
              textAlign: isActions ? 'right' : 'left',
              verticalAlign: 'middle',
            }}
          >
            {cell.render('Cell')}
          </td>
        )
      })}
    </tr>
  )
}

export {CustomRow}
